'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { LayoutRowContainerClass } from 'app/components/styling';

const API = process.env.NEXT_PUBLIC_MO_YOUTUBE_FEED_API!;

interface Channel {
  channel_id: string;
  title: string;
  custom_url: string | null;
  thumbnail_url: string | null;
}

function channelSlug(ch: Channel): string {
  return (ch.custom_url ?? ch.channel_id).replace(/^@/, '').toLowerCase();
}

export function ChannelIndexContent() {
  const [channels, setChannels] = useState<Channel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/channels?whitelisted=true`)
      .then((r) => r.json())
      .then((data: Channel[]) => {
        setChannels(data);
        setLoading(false);
      });
  }, []);

  return (
    <div className="px-4 py-6">
      <div className={`${LayoutRowContainerClass}`}>
        <h1 className="mb-6 font-[family-name:var(--font-zalando-sans)] text-3xl font-extralight text-fg-1">
          All Channels
        </h1>
        {loading ? (
          <p className="text-fg-3">Loading...</p>
        ) : (
          <div className="space-y-2">
            {channels.map((ch) => (
              <Link
                key={ch.channel_id}
                href={`/channel/${channelSlug(ch)}`}
                className="flex items-center gap-3 rounded-xl border border-border-soft bg-card px-4 py-3 shadow-sm ring-1 ring-border-hair hover:bg-card-soft"
              >
                {ch.thumbnail_url && (
                  <img
                    src={ch.thumbnail_url}
                    alt={ch.title}
                    className="h-10 w-10 rounded-full"
                  />
                )}
                <div>
                  <span className="font-sans font-semibold text-fg-1">
                    {ch.title}
                  </span>
                  {ch.custom_url && (
                    <span className="ml-2 text-sm text-fg-3">
                      {ch.custom_url}
                    </span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
